export const color = {
  _ffffff: "#000000",
  _DADADA: "#DADADA",
};
export const btnColor= "#B87333"